var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotAccessible = function SvgNotAccessible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.667,
    height: 18.667,
    viewBox: "0 0 18.667 18.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_off",
    "data-name": "view off",
    transform: "translate(1.061 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24044",
    "data-name": "Path 24044",
    d: "M14.24,16.484a7.573,7.573,0,0,1-4.467,1.549c-5.265,0-8.273-6.017-8.273-6.017A13.876,13.876,0,0,1,5.306,7.549M8.194,6.18A6.859,6.859,0,0,1,9.773,6c5.265,0,8.273,6.017,8.273,6.017a13.913,13.913,0,0,1-1.624,2.4m-5.054-.8a2.256,2.256,0,1,1-3.189-3.189",
    transform: "translate(-1.5 -3.744)",
    fill: "none",
    stroke: "#ff5059",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24045",
    "data-name": "Path 24045",
    d: "M1.5,1.5,18.046,18.046",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#ff5059",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotAccessible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_accessible.b1943cf2.svg";
export { ForwardRef as ReactComponent };